<style src="./EditDocumentType.scss" lang="scss" scoped></style>
<template lang="html">
  <section class="edit-document-type">
    <form
      class="form"
      @submit.prevent="submitForm">
      <label class="form-field">
        <span class="title">Título</span>
        <input
          type="text"
          v-model="form.title"
          placeholder="Edital"
          class="cp1-small-textbox" />
      </label>

      <label class="form-field">
        <span class="title">Descrição</span>
        <textarea
          type="text"
          v-model="form.description"
          placeholder="Edital contendo informações do pregão"
          class="cp1-small-textbox textdescription">
        </textarea>
      </label>
      
      <cp1-form-group
        class="formgroup"
        caption="Listagem dos campos inseridos">
        <ul class="fieldslist">
          <li class="fieldheader">
            <span class="fieldtype">Tipo do campo</span>
            <span class="fieldtitle">Título</span>
          </li>
          <li
            class="emptylist"
            v-if="!(editData.fields && editData.fields.length > 0)">
            <icon-empty class="icon" />
            Não há campos
          </li>
          <li
            class="fielditem"
            v-for="(fieldItem, fieldItemIdx) in editData.fields"
            :key="fieldItemIdx">
            <span class="fieldtype">
              {{ fieldItem.inputType }}
            </span>
            <span class="fieldtitle">
              {{ fieldItem.caption }}
            </span>
          </li>
        </ul>
      </cp1-form-group>

      <div class="commands">
        <button
          type="button"
          class="btn-ghost cancel-button commandbutton"
          @click="closePanel">
          Não desejo salvar
        </button>

        <cp1-button-submit
          class="submit commandbutton"
          :state="commands.submitState"
          label="Salvar Evento"/>
      </div>
    </form>
  </section>
</template>

<script>
import { Cp1ButtonSubmit } from '@/components/primitives'
import { IconWait, IconSave, IconEmpty } from '@/components/primitives/icons'

export default {
  name: 'EditDocumentType',
  components: {
    Cp1ButtonSubmit,
    IconWait,
    IconSave,
    IconEmpty
  },
  props: {
    editData: {
      default: null
    }
  },
  data () {
    return {
      form: {
        title: '',
        description: ''
      },
      commands: {
        saveIcon: IconSave,
        submitState: 'REPOSE'
      }
    }
  },
  mounted () {
    this.fillData()
  },
  methods: {
    fillData () {
      if (this.editData !== null) {
        this.form.title = this.editData.title
        this.form.description = this.editData.description
      }
    },
    async submitForm () {
      try {
        this.commands.submitState = 'WAIT'
        if (this.form.title.trim().length < 2) {
          throw new Error('Campo título não preenchido')
        }
        const form = {
          documentId: this.editData._id,
          ...this.form
        }
        const result = await this.$store.dispatch('DocumentType/EDIT_REGISTER', form)
        if (result) {
          this.$toasted.success('Tipo de document salvo com sucesso')
          await this.$store.dispatch('DocumentType/LIST_PAGINATED')
          this.closePanel()
        }
      } catch (error) {
        this.$toasted.error(error)
      } finally {
        this.commands.submitState = 'REPOSE'
      }
    },
    closePanel () {
      this.$parent.$emit('close', false)
    },
    clearForm () {
      this.form.title = ''
      this.form.description = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/document-type/components/edit-document-type/EditDocumentType.vue